import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

/**
 * streamSSE - fetches an SSE endpoint and yields parsed JSON frames.
 * @param {string} path - path after /api (e.g. "/chat/stream")
 * @param {object} body - JSON body for POST
 * @param {(frame:object)=>void} onFrame - called per frame
 * @param {AbortSignal} signal
 */
export async function streamSSE(path, body, onFrame, signal) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    credentials: "include",
    signal,
  });
  if (!res.ok || !res.body) throw new Error(`Stream failed ${res.status}`);
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop() || "";
    for (const chunk of parts) {
      const line = chunk.trim();
      if (!line.startsWith("data:")) continue;
      const raw = line.slice(5).trim();
      if (!raw) continue;
      try {
        const j = JSON.parse(raw);
        onFrame(j);
      } catch (e) {
        // ignore malformed
      }
    }
  }
}

export async function downloadExport(title, content, format) {
  const res = await fetch(`${API}/export`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ title, content, format }),
  });
  if (!res.ok) throw new Error("Export failed");
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const safe = (title || "document").replace(/[^a-z0-9]+/gi, "_").slice(0, 60);
  a.download = `${safe}.${format}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * logChuck - fire a Chuck telemetry event so Chuck keeps learning from user behavior.
 * Silent no-op if the user is anonymous, on Enterprise, or has not consented — server enforces.
 */
export async function logChuck(event_type, { doc_type, payload, session_id, source_model } = {}) {
  try {
    await api.post("/chuck/event", {
      event_type,
      doc_type: doc_type || null,
      payload: payload || {},
      session_id: session_id || null,
      source_model: source_model || null,
    });
  } catch (_) {
    // silently ignore — Chuck learning must never block the UX
  }
}
